import React from "react"
import MainMenu from "../components/mainmenu"

export default props => 
<div>
    <MainMenu />
    <p>Copyright &copy; 2020 Gary Chambers</p>
</div>